// extracted by mini-css-extract-plugin
export default {"buttonContainer":"SetAdminSuccessPage_buttonContainer__yiKGK"};